import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import useBrandTranslation from "../hooks/useBrandTranslation";
import tr from "../i18n/translate";

const BASE_URL = "/api/mercadopago";

export const useCreateMPPreferenceMutation = async (body) => {
  const res = await fetch(`${BASE_URL}/preferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(tr("app.payments.mpRequestError", "Error en la petición"));
  }
  return res.json();
};

export default function Mercadopago() {
  const { t } = useBrandTranslation();
  const [amount, setAmount] = useState("100");
  const [description, setDescription] = useState(t("app.payments.sampleProduct", "Producto de ejemplo"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const createMutation = useMutation({
    mutationFn: useCreateMPPreferenceMutation,
    onSuccess: (data) => {
      console.log("Preference creada:", data);
    },
    onError: (error) => {
      console.error("Error creando preference:", error);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await createMutation.mutateAsync({
        title: description,
        price: Number.parseFloat(amount),
        quantity: 1,
      });

      if (response.url) {
        window.location.href = response.url;
      } else {
        throw new Error(t("app.payments.mpPaymentUrlError", "No se pudo obtener la URL de pago"));
      }
    } catch (err) {
      console.error("Error al crear preferencia de pago:", err);
      setError(
        t("app.payments.mpProcessError", "Ocurrió un error al procesar el pago. Por favor intenta nuevamente.")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6 pb-4">
        <h2 className="text-xl font-semibold text-gray-900">
          {t("app.payments.paymentFormTitle", "Detalles del pago")}
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          {t("app.payments.paymentFormHint", "Ingresa los detalles para proceder con el pago")}
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* <div className="px-6 pb-4 space-y-4">
          <div className="space-y-2">
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700"
            >
              Descripción
            </label>
            <input
              id="description"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700"
            >
              Monto (ARS)
            </label>
            <input
              id="amount"
              type="number"
              min="1"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
            />
          </div>

          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3">
              {error}
            </div>
          )}
        </div> */}

        <div className="px-6 pb-6">
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-not-allowed text-white font-medium py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center"
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Procesando...
              </>
            ) : (
              t("app.payments.payWithMp", "Pagar con MercadoPago")
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
